<!--dalam pdf kena ada screenshot table/graph-->
<template>
    <div>
        <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
        <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
        <StatusModal :show.sync="modals.removeFailedModal" :message="modal.removeFailed" :title="modal.removeTitle" />

        <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
            <div class="col-lg-3">
                <base-button style="font-size: 18px" @click="getBack()" class="btn-link btn-primary">
                    &lt; Return to Report List
                </base-button>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-12">
                    <card class="card-eprf">
                        <div class="col-lg-12">
                            <div class="row" style="margin-bottom: 10px;">
                                <div class="col-lg">
                                    <p style="color: #358ccb; font-size: 24px; font-weight: 300">
                                        VESSEL GENERATED WASTE
                                    </p>
                                </div>

                                <div class="col-lg-2 text-right">
                                    <base-button type="cancel" :disabled="candelete" v-on:click="deleteRow()">
                                        <i style="color: white; font-size: 18px; font-weight: 900"
                                            class="tim-icons icon-trash-simple"></i>&nbsp; Delete</base-button>
                                </div>
                            </div>

                            <div id="tableku" v-if="load == false">
                                <el-table :data="queriedData" :header-cell-style="{
                                    background: 'transparent',
                                    color: 'gray',
                                }" class="custom-table" style="width: 100%; height: 800px; overflow: auto">
                                    <el-table-column :min-width="50" align="center" prop="index" label="NO">
                                    </el-table-column>
                                    <el-table-column :min-width="200" align="center" prop="username"
                                        label="USER"></el-table-column>
                                    <el-table-column :min-width="200" sortable align="center" prop="lastgenerated"
                                        label="GENERATED DATE"></el-table-column>
                                    <el-table-column :min-width="100" align="center" prop="edit">
                                        <template slot-scope="scope">
                                            <a :href="scope.row.url" download target="_blank">
                                                <base-button type="primary">
                                                    Download
                                                </base-button>
                                            </a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :min-width="50" align="center">
                                        <template slot-scope="scope">
                                            <input type="checkbox"
                                                @change="toggleRowCheck(scope.$index, scope.row.reportid)"
                                                :checked="checkedRows.includes(scope.$index)" />
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div style="
                        height: 100px;
                        padding: 20px 20px 0px 20px;
                        margin: 30px 30px 0px 0px;
                      " class="d-flex justify-content-center spinner" v-if="load === true">
                                <circle-8></circle-8>
                            </div>
                        </div>
                    </card>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <el-select v-model="pagination.perPage" placeholder="Per page">
                            <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                :label="item" :value="item"></el-option>
                        </el-select>

                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total"></base-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Alert,
    Select,
    Option,
    DatePicker,
    Table,
    TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { debounce } from "src/util/debounce";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../../components/Cards/Card.vue";
import Fuse from "fuse.js";
import { BasePagination, BaseSwitch } from "../../../../../src/components";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import StatusModal from 'src/components/StatusModal.vue';
import { modal } from "src/components/variable.js"

export default {
    name: "VesselGeneratedWaste",

    components: {
        Card,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Circle8,
        Fuse,
        BasePagination,
        BaseSwitch,
        html2canvas,
        StatusModal
    },

    data() {
        return {
            pdfdoc: '',
            modal: modal,
            month: '',
            year: '',
            totaltonnagecollection: 0,
            totalnumbercollection: 0,
            checkedRows: [],
            selectedrows: [],
            load: false,
            tableDatas: [],
            tableData: [
                {
                    username: 'Khuz - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Nad - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Acap - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Khuz - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Nad - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Acap - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Khuz - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Nad - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Acap - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Khuz - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Nad - main',
                    lastgenerated: '09/12/2024 14:12',
                },
                {
                    username: 'Acap - main',
                    lastgenerated: '09/12/2024 14:12',
                },
            ],

            modals: {
                submit: false,
                disputee: false,
                uploaddoc: false,
                successModal: false,
                removeModal: false,
                removeFailedModal: false,
            },

            selects: {
                assigner: "",
                assigners: [
                    { value: "00", label: "All" },
                    { value: "01", label: "Yahya Abd Rahman" },
                    { value: "02", label: "Ikhwan Ayub" },
                    { value: "03", label: "Haziq Haikal" },
                ],
                date: "",
                dates: [],
                type: "",
                quostatus: "",
                quostatuses: [],
                servicelocation: "",
                servicelocations: [],
            },

            temp: [],
            searchQuery: "",
            searchedData: [],
            fuseSearch: null,
            currentRow: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50],
                total: 0,
            },

            pdfTable: [
                {
                    no: 1,
                    date: '5/1/2024',
                    servicelocation: 'Anchorage',
                    vesseltype: 'Chemical Tanker',
                    wastetype: 'Annex II',
                    collectionqty: '22.3'
                },
                {
                    no: 2,
                    date: '5/1/2024',
                    servicelocation: 'Anchorage',
                    vesseltype: 'Chemical Tanker',
                    wastetype: 'Annex II',
                    collectionqty: '22.3'
                },
                {
                    no: 3,
                    date: '5/1/2024',
                    servicelocation: 'Anchorage',
                    vesseltype: 'Chemical Tanker',
                    wastetype: 'Annex II',
                    collectionqty: '22.3'
                },
                {
                    no: 4,
                    date: '5/1/2024',
                    servicelocation: 'Anchorage',
                    vesseltype: 'Chemical Tanker',
                    wastetype: 'Annex II',
                    collectionqty: '22.3'
                },
            ],
        };
    },
    methods: {
        download(url) {

        },
        getData(api) {
            this.load = true;
            this.tableDatas = [];

            this.$http.get(":10001" + api + "/log").then((res) => {
                if (!res.error) {
                    this.load = false;
                    let response = res.message;

                    for (var i = 0; i < response.length; i++) {
                        let obj = {
                            index: i +
                                1 +
                                this.pagination.perPage * (this.pagination.currentPage - 1),
                            username: response[i].UserName,
                            lastgenerated: moment(response[i].created_at).format("YYYY-MM-DD HH:mm"),
                            url: response[i].Url,
                            reportid: response[i].Id,
                        };

                        this.tableDatas.push(obj);
                        this.temp.push(obj);
                    }
                }
            });
        },
        getBack() {
            this.$router.push("/Reports");
        },
        getServiceLocation() {
            this.selects.servicelocations = [];

            this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
                if (!res.error) {
                    let response = res.message;

                    for (var i = 0; i < response.length; i++) {
                        let obj = {
                            label: response[i].Location,
                            value: response[i].ServiceLocationId,
                        };
                        this.selects.servicelocations.push(obj);
                    }
                }
            });
        },
        async getpdfData(locationID, startdate, enddate) {
            this.pdfTable = [];

            let formatter = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            await this.$http.get(":10001/api/v1/report/monthly_authority?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + locationID).then((res) => {
                if (!res.error) {
                    let response = res.message;

                    this.year = response.Year;
                    this.month = response.Month;
                    this.totaltonnagecollection = response.TotalTonnageCollection;
                    this.totalnumbercollection = response.TotalNumberOfCollection;

                    if (response.Data !== null)
                        for (var i = 0; i < response.Data.length; i++) {
                            let obj = {
                                no: response.Data[i].No,
                                date: moment(response.Data[i].Date).format("YYYY-MM-DD"),
                                servicelocation: response.Data[i].ServiceLocation,
                                vesseltype: response.Data[i].TypeOfVessel,
                                wastetype: response.Data[i].TypeOfWaste,
                                collectionqty: formatter.format(response.Data[i].TotalCollectionQuantity),
                            };
                            this.pdfTable.push(obj);
                        }
                }
            });
        },

        async getDownload(imageroute, dategenerated, locationID, startdate, enddate, api) {
            await this.getpdfData(locationID, startdate, enddate);

            return new Promise((resolve) => {

                console.log('generate report vessel generated waste', dategenerated);

                let doc = jsPDF({
                    orientation: "potrait",
                });

                html2canvas(imageroute, {
                    width: 1800,
                    height: 1300,
                }).then((canvas) => {
                    const img = canvas.toDataURL("image/png");

                    const logo = new Image();
                    logo.src = require("@/assets/img/afesnew.png");
                    logo.onload = () => {
                        this.options = Object.assign({}, this.options, {
                            logo: {
                                logo,
                            },
                        });
                    };

                    const data = this.pdfTable;

                    const columns = [
                        "No.",
                        "Date",
                        "Service Location",
                        "Type of Vessel",
                        "Type of Waste",
                        "Total Collection Quantity (MT)"
                    ];

                    const rows = this.pdfTable.length !== 0 ? data.map((obj) => [
                        obj.no,
                        obj.date,
                        obj.servicelocation,
                        obj.vesseltype,
                        obj.wastetype,
                        obj.collectionqty,
                    ]) :
                        [
                            [{
                                content: 'No data', colSpan: 6, styles: {
                                    halign: 'center',
                                    valign: 'middle',
                                },
                            }]]
                        ;

                    let formatter = new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });

                    const footerrows = [
                        [{
                            content: 'Total Tonnage Collection', colSpan: 5, styles: {
                                fillColor: [221, 235, 247], fontStyle: 'bold', halign: 'center',
                                valign: 'middle',
                            },
                        },
                        {
                            content: formatter.format(this.totaltonnagecollection), styles: {
                                fontStyle: 'normal',
                                halign: 'center',
                                valign: 'middle',
                            }
                        }
                        ],
                        [{
                            content: 'Total Number of Collection', colSpan: 5, styles: {
                                fillColor: [221, 235, 247], fontStyle: 'bold', halign: 'center',
                                valign: 'middle',
                            },
                        },
                        {
                            content: formatter.format(this.totalnumbercollection), styles: {
                                fontStyle: 'normal',
                                halign: 'center',
                                valign: 'middle',
                            }
                        }],
                    ];

                    doc.addImage(
                        logo,
                        "PNG",
                        15,
                        5,
                        50,
                        18.75
                    );

                    doc.setFontSize(11);
                    doc.setFontStyle("bold");

                    doc.text(
                        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD (AFES)",
                        70,
                        10
                    );

                    doc.text(
                        "PORT RECEPTION FACILITIES (PRF) NORTHPORT",
                        70,
                        15
                    );

                    doc.setTextColor(13, 112, 192);
                    doc.text(
                        "VESSEL GENERATED WASTE REPORT",
                        70,
                        20
                    );

                    doc.setFontStyle("normal");

                    doc.setTextColor(104, 104, 104);
                    doc.text(
                        "Duration",
                        70,
                        25
                    );

                    doc.text(
                        ": " + moment(startdate).format("MMMM YYYY"),
                        95,
                        25
                    );

                    doc.addImage(
                        img,
                        "PNG",
                        15,
                        30,
                        200,
                        150,
                    );

                    const table = doc.autoTable({
                        head: [columns],
                        showHead: "firstPage",
                        headStyles: {
                            fillColor: [0, 32, 96],
                            textColor: [255, 255, 255],
                            halign: 'center',
                            valign: 'middle',
                        },
                        columnStyles: {
                            0: {
                                halign: "center",
                                valign: 'middle',
                                cellWidth: 10,
                            },
                            1: {
                                halign: "center",
                                valign: 'middle',
                            },
                            2: {
                                halign: "center",
                                valign: 'middle',
                            },
                            3: {
                                halign: "center",
                                valign: 'middle',
                            },
                            4: {
                                halign: "center",
                                valign: 'middle',
                            },
                            5: {
                                halign: "center",
                                valign: 'middle',
                            },
                        },
                        styles: {
                            lineWidth: 0.1,
                            lineColor: [0, 0, 0],
                        },
                        theme: "plain",
                        body: rows,
                        foot: footerrows,
                        showFoot: "lastPage",
                        startY: 150,
                    });

                    doc.setTextColor(0, 0, 0);

                    const tableHeight = table.autoTable.previous.finalY;

                    doc.text(
                        dategenerated,
                        15,
                        tableHeight + 10,
                    );
                    doc.text(
                        "This is a computer-generated document. No signature is required.",
                        15,
                        tableHeight + 15,
                    );

                    doc.save("Vessel Generated Waste.pdf");
                    const pdfBlob = doc.output("blob");
                    this.pdfdoc = pdfBlob;

                    if (pdfBlob) {
                        this.pdfdoc = pdfBlob;
                        this.uploadLog(api, locationID, startdate, enddate);

                        setTimeout(() => {
                            this.getData(this.$route.query.apiData);
                        }, 1000);
                        console.error("PDF generation success");
                    } else {
                        console.error("PDF generation failed");
                    }
                    resolve();
                });
            });
        },
        uploadLog(api, locationID, startdate, enddate) {
            const formData = new FormData();
            formData.append("document", this.pdfdoc);

            this.$http
                .post(":10001" + api + "?start_date=" + startdate + "&end_date=" + enddate + "&service_location_id=" + locationID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + sessionStorage.getItem("token"),
                        },
                    }
                )
                .then((res) => {
                    if (!res.error) {
                        console.log('apa jadi', res.message);
                    } else {
                        console.log("generate failed", response);
                    }
                }).catch((err) => {
                });
        },
        toggleRowCheck(index, reportid) {
            const rowIndex = this.checkedRows.indexOf(reportid);
            if (rowIndex > -1) {
                this.checkedRows.splice(rowIndex, 1);
            } else {
                this.checkedRows.push(reportid);
            }
        },
        deleteRow() {
            let datas = [];
            for (var i = 0; i < this.checkedRows.length; i++) {
                datas.push(this.checkedRows[i]);
            }
            console.log(datas);

            let obj = {
                Id: datas
            };

            console.log('obj', obj);

            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-primary btn-fill",
                cancelButtonClass: "btn btn-cancel btn-fill",
                confirmButtonText: "Continue",
                buttonsStyling: false,
            }).then((result) => {
                if (result.value == true) {
                    this.$http
                        .post(
                            ":10001" +
                            this.$route.query.apiData + "/delete", obj
                        )
                        .then((res) => {
                            if (!res.error) {
                                this.modals.removeModal = true;

                                setTimeout(() => {
                                    this.getData(this.$route.query.apiData);
                                }, 1000);
                            } else {
                                this.modals.removeFailedModal = true;
                            }
                        });
                }
            });
        }
    },
    mounted() {
        this.getData(this.$route.query.apiData);
        this.getServiceLocation();
    },
    watch: {
        checkedRows(newVal) {
            console.log('Checked rows:', newVal); // Log or do anything with the checked row numbers
        },
        searchQuery: debounce(function (search) {
            console.log(search);
            if (search != "") {
                this.tableDatas = this.temp.filter(
                    (value) =>
                        value.jobno.toLowerCase().includes(search.toLowerCase()) ||
                        (value.jobflag &&
                            value.jobflag.toLowerCase().includes(search.toLowerCase())) ||
                        value.customer.toLowerCase().includes(search.toLowerCase())
                );
            } else {
                this.tableDatas = this.temp;
            }
        }, 500),
    },
    computed: {
        candelete() {
            return this.checkedRows.length === 0;
        },
        queriedData() {
            let result = this.tableDatas;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableDatas.length;
        },
    },
};
</script>
<style></style>